import React, { useState, useEffect } from 'react'
import api from "../api/dataSource"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col
} from 'reactstrap';
import classnames from 'classnames'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'

const Equipos = ({idCampeonato}) => {
  const [equipos, setEquipos] = useState([])
  const [jugadores, setJugadores] = useState([])
  const [esEquipos, setEsEquipos] = useState(true)
  const [currentEquipo, setCurrentEquipo] = useState('')
  const MySwal = withReactContent(Swal)

  const getEquipos = (ide) => {
    api.getCampeonato(`api/obtener_equipos_pagina/${ide}`).then((resp) => {
      setEquipos(resp)
    }).catch(error => {
      console.log(error)
    })
  }

  const mostrarJugadores = ({id, nombre}) => {
    MySwal.showLoading();
    MySwal.disableButtons();
    api.getCampeonato(`api/obtener_jugadores_pagina/${idCampeonato}/${id}`).then((resp) => {
      MySwal.close()
      setJugadores(resp.data)
      setEsEquipos(false)
      setCurrentEquipo(nombre)
    }).catch(error => {
      MySwal.close()
    })
  }

  const numero = 1
  useEffect(() => {
    getEquipos(idCampeonato)
  }, [numero])

  return (
    <Row>
      <Col sm="12">
        {
          esEquipos
          ? (
            <Row style={{textAlign: 'center'}}>
              {
                equipos.map(x => (
                  <Col sm="12" md="3" key={x.id}>
                    <Card body style={{cursor: 'pointer'}} onClick={() => mostrarJugadores(x)}>
                      {
                        !!x.multimedia
                        ? (
                          <img className="centro" style={{ width: '80px' }} src={`data:image/jpeg;base64,${x.foto}`} alt="Logo" />
                        )
                        : (
                          <img className="centro" style={{ width: '80px' }} src="SINLOGO.png" alt="logo" />
                        )
                      }
                      <br /> 
                      <span>{x.nombre}</span>
                    </Card>
                  </Col>
                ))
              }
            </Row>
          )
          : (
            <>
            <Row>
              <Col sm="6">
                <h3>Jugadores de {currentEquipo}</h3>
              </Col>
              <Col sm="6" style={{textAlign: 'right'}}>
                <Button onClick={() => setEsEquipos(true)} color="secondary">Regresar a la lista de Equipos</Button>
              </Col>
            </Row>
            <br />
            <br />
            <Row style={{textAlign: 'center'}}>
              {
                jugadores.map(y => (
                  <Col sm="12" md="3" key={y.id}>
                    <Card body>
                      {
                        !!y.foto
                        ? (
                          <img className="centro" style={{ width: '80px' }} src={`data:image/jpeg;base64,${y.foto}`} alt="Logo" />
                        )
                        : (
                          <img className="centro" style={{ width: '80px' }} src="SINLOGO.png" alt="logo" />
                        )
                      }
                      <br /> 
                      <span>{y.nombre}</span>
                    </Card>
                  </Col>
                ))
              }
            </Row>
            </>
          )
        }
      </Col>
    </Row>
  )
}

export default Equipos
